'use strict';
const _ = require('lodash');
let stage = process.env.stage || process.env.NODE_ENV || 'dev';
if ('development' == stage) {
	stage = 'dev';
}

let config = {
	default: {
		system_api_key: 'ba3ec450-5ea2-11ea-bd59-d78dab67a7f9',
		domain: 'admin.glowpick.net',
		admin_host: 'https://admin.glowpick.net',
		image_host: 'https://dn5hzapyfrpio.cloudfront.net',
		api_es_j: 'https://api-es-j.glowpick.net',
	},

	dev: {},

	production: {
		domain: 'admin.glowpick.com',
		admin_host: 'https://admin.glowpick.com',
		api_es_j: 'https://api-es-j.glowpick.com',
	},
};

config[stage].stage = config[stage].env = stage;
module.exports = _.assign(config.default, config[stage]);
